import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "hand-pointer-o",
  "use": "hand-pointer-o-usage",
  "viewBox": "0 0 416 448",
  "content": "<symbol viewBox=\"0 0 416 448\" id=\"hand-pointer-o\"><path d=\"M160 32c-17.75 0-32 14.25-32 32v224l-37.75-50.5C84 229.25 74 224 63.5 224 46 224 32 238.75 32 256c0 7 2.25 13.75 6.5 19.25l96 128c6 8 15.5 12.75 25.5 12.75h179.5c7.25 0 13.75-5 15.5-12l23-92c4-16 6-32.25 6-48.5v-54.25C384 196 373.75 184 360 184c-13.25 0-24 10.75-24 24h-8v-15.25C328 177 316 164 300 164c-15.5 0-28 12.5-28 28v16h-8v-22.5c0-18-13.75-33.5-32-33.5-17.75 0-32 14.25-32 32v24h-8V65.5c0-18-13.75-33.5-32-33.5zm0-32c35.75 0 64 30 64 65.5v55c2.75-.25 5.25-.5 8-.5 16.25 0 31.5 6.25 43.25 17.25C283 133.75 291.5 132 300 132c18 0 34.75 8 46 21.75 4.75-1.25 9.25-1.75 14-1.75 31.5 0 56 26.25 56 57.25v54.25c0 18.75-2.25 37.75-7 56.25l-23 92C380.75 433 361.5 448 339.5 448H160c-20 0-39.25-9.75-51.25-25.5l-96-128C4.5 283.5 0 269.75 0 256c0-35 28.5-64 63.5-64 11.5 0 22.75 3 32.5 8.75V64c0-35.25 28.75-64 64-64zm32 352v-96h-8v96h8zm64 0v-96h-8v96h8zm64 0v-96h-8v96h8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hand-pointer-o.svg
// module id = cA6q
// module chunks = 1